import {Component, OnInit, Input, Output, EventEmitter, OnChanges, SimpleChanges} from '@angular/core';
import {EnvService} from "../services/env.service";
import {HttpClient, HttpParams} from "@angular/common/http";

@Component({
  selector: 'micro-service-help',
  templateUrl: './service-help.component.html'
})
export class ServiceHelpComponent implements OnInit, OnChanges  {
  services:any[];

  @Input()
  companyId:any;

  constructor(private env:EnvService, private http:HttpClient) {
  }

  ngOnChanges(changes: SimpleChanges): void {
    for (let prop in changes) {
      if (prop === 'companyId') {
        this.reload();
      }
    }
  }

  ngOnInit() {
    if (!this.companyId) {
      this.reload();
    }
  }

  reload() {
    let params:HttpParams = new HttpParams();
    if (this.companyId && this.companyId !== '') {
      params = params.set("companyId", this.companyId);
    }

    this.http.get(`${this.env.e.url}/auth/services`, {params:params}).subscribe(
      data => {
        this.services = data as any[];
      }
    );
  }
}
